import { useQuery } from "@tanstack/react-query";
import { useDataSource } from "@/data/DataProvider";
import { useIdentity } from "@/auth/ClientAuthProvider";

/** Everything the journey tracker and the view mode are decided from. */
export function useJourneyFacts() {
  const source = useDataSource();
  const id = useIdentity();
  return useQuery({
    queryKey: ["journey", id.orgId, id.leadId],
    queryFn: () => source.getJourneyFacts(id),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
